// src/App.js
import React from 'react';
import BeautyStationInfo from './pages/BeautyStationInfo';
import './App.css';

function App() {
  return (
    <div className="App">
      <BeautyStationInfo />
    </div>
  );
}

export default App;
